module.exports = __webpack_public_path__ + "img/avatar1.f64d3f02.jpg";